
import get from 'lodash.get';
import { createSelector } from 'reselect';

const appEntitiesSelector = (state: TReduxState) => state.root.entities.app;

export const getTodayQuestions = createSelector(appEntitiesSelector, (appData) =>
  get(appData, 'todayQuestions', [])
);

export const selectChatsdownStatus = createSelector(appEntitiesSelector, (data) => data.chatsDropsdown);

export const getNotificationContent = createSelector(appEntitiesSelector, (data) => data.notificationContent);
export const selectCurrencies = createSelector(appEntitiesSelector, (data) => data.currencies);
export const selectUserFaqs = createSelector(appEntitiesSelector, (data) => data.faqs);
export const selectUserSelectedPlan = createSelector(appEntitiesSelector, (data) => data.selectedPlan);
export const selectUserFeatures = createSelector(appEntitiesSelector, (data) => data.features);

